import React, { useEffect } from 'react';
import { NextPage } from 'next';
import NewPostService from 'components/community/_new_post';
import { SubHeaderAuthOptions } from 'constants/index';
import SubHeader from 'components/common/SubHeader';
import { useSelector } from 'store';
import { useRouter } from 'next/router';
import { routeManager } from 'utils/routeGuard';
import { cookieStringToObject, makeAuthorizationConfig } from 'utils';
import { AxiosResponse } from 'axios';
import { GetNoticeFixed, GetNoticesAPI, GetRecentPostAPI } from 'api/community';
import { communityActions } from 'store/community';
import { ERROR_500 } from 'constants/message';
import { GetRegionsAPI } from 'api/space';
import { spaceActions } from 'store/space';

interface IProps {
  error?: boolean;
}

const NewPost: NextPage<IProps> = ({ error }: IProps) => {
  const router = useRouter();
  const member = useSelector(state => state.membership.member);
  const isLogin = useSelector(state => state.accounts.isLogin);
  const isActive =
    member !== null &&
    (member.status === 'ACTIVE' || member.status === 'EXPIRING');

  useEffect(() => {
    if (!isLogin) {
      router.push('/auth/login');
      return;
    }

    if (error) {
      alert(ERROR_500);
      router.push('/');
      return;
    }

    if (!member) {
      router.push('/error/not_membership');
    } else if (!isActive) {
      routeManager(router, member.status);
    }
  }, [error, isActive, isLogin, member, router]);

  if (!isLogin || !isActive || error) {
    return null;
  }

  return (
    <>
      <SubHeader options={SubHeaderAuthOptions} selected="커뮤니티" />
      <NewPostService />
    </>
  );
};

NewPost.getInitialProps = async ({ req, store }) => {
  const access =
    req === undefined
      ? store.getState().accounts.access
      : cookieStringToObject(req?.headers.cookie).access_token;

  const config = makeAuthorizationConfig(access);

  const response: AxiosResponse = await GetRecentPostAPI(config);
  const notices: AxiosResponse = await GetNoticesAPI(config, 10);
  const noticesFixed: AxiosResponse = await GetNoticeFixed();
  const regions: AxiosResponse = await GetRegionsAPI();

  if (
    response.status >= 400 ||
    notices.status >= 400 ||
    noticesFixed.status >= 400 ||
    regions.status >= 400
  ) {
    return {
      error: true,
    };
  }

  store.dispatch(communityActions.getCommunityList(response.data));
  store.dispatch(communityActions.getNotices(notices.data));
  store.dispatch(communityActions.getNoticesFixed(noticesFixed.data));
  store.dispatch(spaceActions.getRegions(regions.data));

  return {
    error: false,
  };
};

export default NewPost;
